import gql from 'graphql-tag';

const STOCKTAKE_ITEMS_FRAGMENT = gql`
	fragment stocktakeItem on StocktakeItem {
		id
		countedExpiryBatches
		warehouseProduct {
			id
			pickOrder
			quantity
			rootTenant {
				id
				timezone
			}
			tenants {
				id
				timezone
			}
			expiryBatchPreview
			expiryBatchSummary
			expiryBatches {
				id
				quantityOnHand
				expiryDate
				bestBeforeDate
				supplierBatchCode
				status
				receivedAt
				expiryDateSource
			}
			product {
				id
				name
				cost
				imageUrl
				destroyed
				measurementUnit
				caseSize
				shipperSize
				palletSize
				forceQuantityInUnits
				barcodes
				overridingWarehouseProduct {
					id
					name
				}
				}
		}
		preStocktakeQuantity
		quantity
	}
`;

export const GET_STOCKTAKE_ITEMS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: StocktakeItemPageFilter
	) {
		getStocktakeItems(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...stocktakeItem
			}
			count
		}
	}
	${STOCKTAKE_ITEMS_FRAGMENT}
`;

export const SUBSCRIBE_TO_STOCKTAKE_ITEM = gql`
	subscription ($input: StocktakeItemSubscriptionInput!) {
		StocktakeItemSubscription(input: $input) {
			stocktakeitem {
				...stocktakeItem
			}
			destroyedStocktakeItemId
		}
	}
	${STOCKTAKE_ITEMS_FRAGMENT}
`;
